export default __webpack_public_path__ + "static/media/enghien13.980ce6aa.jpg";